// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import { interpolateBlues, interpolateGreys, interpolatePurples, interpolateYlOrBr, schemeCategory10 } from 'd3-scale-chromatic';
import isNil from 'lodash-es/isNil';
import moment from 'moment-timezone';
import { scaleLinear, scaleOrdinal } from 'victory-vendor/d3-scale';
import TimeSteps from '../../enums/TimeSteps';
const interpolateWaterElectroconductivity = (value) => 
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
scaleLinear().domain([0, 0.5, 1]).range(['#129EAE', '#2BCDDE', '#00E7FF'])(value);
const interpolateRdYlBu = (value) => 
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
scaleLinear()
    .domain([0, 0.5, 0.6, 1])
    .range(['#E13D21', '#E5BE59', '#31BDFF', '#0061F7'])(value);
const interpolateSSI = (value) => 
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
scaleLinear().domain([0, 0.6, 1]).range(['#00076e', '#cbcb0b', '#ff6700'])(value);
export const to01 = (domain, range = [0, 1]) => scaleLinear().domain(domain).range(range);
export const to10 = (domain) => to01(domain, [1, 0]);
export const defaultNumberOfSignificantDigits = 1;
export const getYDomainPerMetric = ({ metric, unit, timeStep, min, max }) => {
    switch (metric) {
        case 'T':
        case 'TN':
        case 'TX':
        case 'T_WET':
        case 'T_DRY':
        case 'T_DEW':
            if (!isNil(min) && !isNil(max)) {
                return [min, max];
            }
            switch (unit) {
                case 'degrees_fahrenheit': {
                    return [-5, 100];
                }
                case 'kelvins': {
                    return [250, 320];
                }
                default: {
                    // return a default domain in °C
                    return [-20, 40];
                }
            }
        case 'CAPA':
        case 'U_CAPA':
            return !isNil(max) ? [0, max] : [0, 100];
        case 'ECP': {
            if (!isNil(min) && !isNil(max)) {
                return [min, max];
            }
            else {
                switch (unit) {
                    case 'decisiemens_per_meter':
                        return [3, 6];
                    case 'millisiemens_per_meter':
                    default: {
                        return [300, 600];
                    }
                }
            }
        }
        case 'U':
        case 'UN':
        case 'UX':
            return [0, 100];
        case 'SWC':
            if (!isNil(min) && !isNil(max)) {
                return [min, max];
            }
            else {
                return [0, 100];
            }
        case 'etp': {
            let domain = [0, 0];
            switch (timeStep) {
                case TimeSteps.perQuarterHours:
                case TimeSteps.maximum:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 0.1];
                                break;
                            default:
                                // return a default domain in mm
                                domain = [0, 2];
                                break;
                        }
                    }
                    break;
                case TimeSteps.perHours:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 0.2];
                                break;
                            default:
                                domain = [0, 4];
                                break;
                        }
                    }
                    break;
                case TimeSteps.perWeek:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 2];
                                break;
                            default:
                                domain = [0, 40];
                                break;
                        }
                    }
                    break;
                case TimeSteps.perMonth:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 10];
                                break;
                            default:
                                domain = [0, 250];
                                break;
                        }
                    }
                    break;
                default: {
                    switch (unit) {
                        case 'inches':
                            domain = [0, 0.4];
                            break;
                        default:
                            domain = [0, 10];
                            break;
                    }
                }
            }
            if (!isNil(max) && domain[1] < max) {
                domain = [0, max];
            }
            return domain;
        }
        case 'RR':
        case 'IRR':
        case 'rainfallIntensity':
        case 'RRAccumulation': {
            let domain = [0, 0];
            switch (timeStep) {
                case TimeSteps.perQuarterHours:
                case TimeSteps.maximum:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 0.1];
                                break;
                            default:
                                // return a default domain in mm
                                domain = [0, 2];
                                break;
                        }
                    }
                    break;
                case TimeSteps.perHours:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 0.2];
                                break;
                            default:
                                domain = [0, 4];
                                break;
                        }
                    }
                    break;
                case TimeSteps.perDays:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 0.8];
                                break;
                            default:
                                domain = [0, 20];
                                break;
                        }
                    }
                    break;
                case TimeSteps.perWeek:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 3];
                                break;
                            default:
                                domain = [0, 80];
                                break;
                        }
                    }
                    break;
                case TimeSteps.perMonth:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 6];
                                break;
                            default:
                                domain = [0, 150];
                                break;
                        }
                    }
                    break;
                case TimeSteps.per4Hours:
                    {
                        switch (unit) {
                            case 'inches':
                                domain = [0, 0.8];
                                break;
                            default:
                                domain = [0, 16];
                                break;
                        }
                    }
                    break;
                default: {
                    switch (unit) {
                        case 'inches':
                            domain = [0, 1];
                            break;
                        default:
                            domain = [0, 30];
                            break;
                    }
                }
            }
            if (!isNil(max) && domain[1] < max) {
                domain = [0, max];
            }
            return domain;
        }
        case 'FF':
            if (!isNil(min) && !isNil(max)) {
                return [min, max];
            }
            switch (unit) {
                case 'meters_per_second': {
                    return [0, 10];
                }
                case 'miles_per_hour': {
                    return [0, 25];
                }
                case 'beaufort': {
                    return [0, 12];
                }
                default: {
                    // return a default domain in km/h
                    return [0, 30];
                }
            }
        case 'FXY':
            if (!isNil(min) && !isNil(max)) {
                return [min, max];
            }
            switch (unit) {
                case 'meters_per_second': {
                    return [0, 60];
                }
                case 'miles_per_hour': {
                    return [0, 125];
                }
                case 'beaufort': {
                    return [0, 12];
                }
                default: {
                    // return a default domain in km/h
                    return [0, 200];
                }
            }
        case 'DXY':
        case 'DD':
            return [0, 360];
        case 'HPOT':
            return !isNil(max) ? [0, max] : [0, 200];
        case 'T_CAPA':
        case 'T_CAL':
        case 'T_SOIL':
            if (!isNil(min) && !isNil(max)) {
                return [min, max];
            }
            switch (unit) {
                case 'degrees_fahrenheit': {
                    return [20, 90];
                }
                case 'kelvins': {
                    return [265, 300];
                }
                default: {
                    // return a default domain in °C
                    return [-5, 30];
                }
            }
        case 'LW_D':
            switch (unit) {
                case 'hours': {
                    return [0, 2];
                }
                default: {
                    // seconds
                    return [0, 2 * 60 * 60];
                }
            }
        case 'LW_V':
            // return a default domain in LWS intensity level as we never display the value in mV
            return [0, 10];
        case 'heatAccumulation':
            if (!isNil(min) && !isNil(max)) {
                return [min, max];
            }
            switch (unit) {
                case 'fahrenheit_degrees_day': {
                    return [0, 1080];
                }
                case 'kelvins': {
                    return [0, 873];
                }
                default: {
                    // return a default domain in accumulation of °C
                    return [0, 600];
                }
            }
        case 'PPFD':
        case 'PPFD_MAX':
        case 'PPFD_MIN':
        case 'SSI':
        case 'SSI_MAX':
        case 'SSI_MIN':
            if (!isNil(min) && !isNil(max)) {
                return [min, max];
            }
            switch (unit) {
                case 'photosynthetic_photon_flux_density':
                case 'watts_per_square_meter':
                    return [0, 300];
                default:
                    return [0, 300];
            }
        case 'COLD_T_HOUR':
        case 'SSI_HOURS':
        case 'SSI_HOURSAccumulation':
            if (!isNil(min) && !isNil(max)) {
                return [min, max];
            }
            switch (unit) {
                case 'hours': {
                    return [0, 1000];
                }
                default: {
                    return [0, 1000];
                }
            }
        case 'VPD':
            switch (unit) {
                case 'kilopascals': {
                    return [0, 2];
                }
                default: {
                    return [0, 2];
                }
            }
        case 'VOLT':
        case 'DRN':
        case 'HDEF':
            return [Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER];
        default:
            return [Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER];
    }
};
export const getColorScalePerMetric = (metric) => {
    switch (metric) {
        case 'ECP':
            return (domain) => (value) => interpolateWaterElectroconductivity(to10(domain)(value));
        case 'T_WET':
        case 'T_DRY':
        case 'T':
        case 'TN':
        case 'TX':
            return (domain) => (value) => interpolateRdYlBu(to10(domain)(value));
        case 'U':
        case 'UN':
        case 'UX':
            return (domain) => (value) => interpolatePurples(to01(domain)(value));
        case 'SWC':
        case 'RR':
        case 'etp':
            return (domain) => (value) => interpolateBlues(to01(domain, [value === 0 ? 0 : 0.1, 1])(value));
        case 'FF':
            return (domain) => (value) => interpolateGreys(to01(domain, [value === 0 ? 0 : 0.4, 1])(value));
        case 'FXY':
            return (domain) => (value) => interpolateGreys(to01(domain, [value === 0 ? 0 : 0.1, 1])(value));
        case 'U_CAPA':
        case 'HPOT':
            return (domain) => (value) => {
                return scaleOrdinal(schemeCategory10).range()[
                // from a value included in domain give me a value that is an integer between 0 and 9
                Math.floor(scaleLinear([0, 9]).domain(domain)(value))];
            };
        case 'T_CAPA':
        case 'T_CAL':
        case 'T_SOIL':
            return (domain) => (value) => interpolateYlOrBr(to10(domain)(value));
        case 'LW_V':
            return () => (value) => {
                if (value >= 687) {
                    //intensity 7 +
                    return '#0B3A64';
                }
                else if (value >= 633) {
                    //intensity 6
                    return '#1F4F7A';
                }
                else if (value >= 579) {
                    //intensity 5
                    return '#2969A3';
                }
                else if (value >= 525) {
                    //intensity 4
                    return '#2E75B6';
                }
                else if (value >= 470) {
                    //intensity 3
                    return '#488FD1';
                }
                else if (value >= 416) {
                    //intensity 2
                    return '#71A8DB';
                }
                else if (value >= 362) {
                    //intensity 1
                    return '#C1E1FF';
                }
                else {
                    //intensity 0
                    return '#FFFFFF';
                }
            };
        case 'SSI':
        case 'SSI_MAX':
        case 'SSI_MIN':
            return (domain) => (value) => interpolateSSI(to01(domain)(value));
        default:
            return (domain) => (value) => interpolateGreys(to01(domain)(value));
    }
};
export const computeUntilMidnight = (rainsfallsForecast, timezone) => {
    const firstTimestampToKeep = moment().tz(timezone).add(1, 'hours').startOf('hour').unix();
    return rainsfallsForecast.reduce((sum, [timestamp, value]) => {
        if (parseInt(timestamp, 10) >= firstTimestampToKeep) {
            if (isNil(sum)) {
                return value;
            }
            else {
                return (sum += value || 0);
            }
        }
        return sum;
    }, null);
};
